module.exports = __webpack_public_path__ + "img/18-plus-chile.a1746f3f.png";